export default __webpack_public_path__ + "static/media/population.71b14aa5.svg";